import { render, staticRenderFns } from "./StockInventoryRegradingRecords.vue?vue&type=template&id=5f79c6ed&scoped=true&"
import script from "./StockInventoryRegradingRecords.vue?vue&type=script&lang=js&"
export * from "./StockInventoryRegradingRecords.vue?vue&type=script&lang=js&"
import style0 from "./StockInventoryRegradingRecords.vue?vue&type=style&index=0&id=5f79c6ed&scoped=true&lang=css&"
import style1 from "./StockInventoryRegradingRecords.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f79c6ed",
  null
  
)

export default component.exports
import {QTable,QSpace,QBtn,QTooltip,QTh,QTr,QTd,QCardSection} from 'quasar'
component.options.components = Object.assign({QTable,QSpace,QBtn,QTooltip,QTh,QTr,QTd,QCardSection}, component.options.components || {})
